import { useMatch } from 'react-router';

export const useEditFormShortcuts = () => {
  const matchNewClearingMapping = useMatch('/chart-of-accounts/:chartOfAccountsId/clearing-mappings/new');
  const matchEditClearingMapping = useMatch('/chart-of-accounts/:chartOfAccountsId/clearing-mappings/:mappingId');
  const matchNewAgreement = useMatch('/chart-of-accounts/:chartOfAccountsId/agreements/new');
  const matchEditAgreement = useMatch('/chart-of-accounts/:chartOfAccountsId/agreements/:agreementId');
  const matchNewAccountingMapping = useMatch('/chart-of-accounts/:chartOfAccountsId/accounting-mappings/new');
  const matchEditAccountingMapping = useMatch('/chart-of-accounts/:chartOfAccountsId/accounting-mappings/:id');
  const matchNewAccountingRule = useMatch('/chart-of-accounts/:chartOfAccountsId/accounting-rules/new');
  const matchEditAccountingRule = useMatch('/chart-of-accounts/:chartOfAccountsId/accounting-rules/:id');
  const matchIncomingSettlement = useMatch('/incoming-settlements/:id');
  const matchSettlementSignOff = useMatch('/settlement-sign-off');
  const matchManualSettlement = useMatch('/manual-settlement');
  const matchAnnexClearingResult = useMatch('/annex-clearing-result');
  const matchSettlementImport = useMatch('/incoming-settlements/:id/settlement-import');
  const matchReportTemplate = useMatch('/report-templates/:id');
  const matchUpdateReportTemplate = useMatch('/report-templates/:id/update-template');

  return Boolean(
    matchNewClearingMapping ||
    matchEditClearingMapping ||
    matchNewAgreement ||
    matchEditAgreement ||
    matchNewAccountingMapping ||
    matchEditAccountingMapping ||
    matchNewAccountingRule ||
    matchEditAccountingRule ||
    matchIncomingSettlement ||
    matchSettlementSignOff ||
    matchManualSettlement ||
    matchAnnexClearingResult ||
    matchSettlementImport ||
    matchReportTemplate ||
    matchUpdateReportTemplate
  );
};

export const useSearchPageShortcuts = () => {
  const matchAgreementsSearch = useMatch('/chart-of-accounts/:chartOfAccountsId/agreements');
  const matchClearingMappingsSearch = useMatch('/chart-of-accounts/:chartOfAccountsId/clearing-mappings');
  const matchAccountingMappingsSearch = useMatch('/chart-of-accounts/:chartOfAccountsId/accounting-mappings');
  const matchAccountingRulesSearch = useMatch('/chart-of-accounts/:chartOfAccountsId/accounting-rules');

  return Boolean(
    matchAgreementsSearch || matchClearingMappingsSearch || matchAccountingMappingsSearch || matchAccountingRulesSearch
  );
};
